import React, { useState } from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedDate from "pages/_components/FormattedDate";
import * as numberUtils from "util/number";
import { statusTagColor } from "util/thirdPayment";
import InfoTag from "pages/echeck/components/InfoTag";
import { COMEX_STATE } from "pages/comex/constants";
import Drawer from "pages/_components/Drawer/Drawer";
import * as i18n from "util/i18n";
import Compose from "./Compose";

const TransactionItem = ({ transaction, isDesktop, viewTicket, type, setActionDrawer }) => {
    const options = [
        {
            text: "comexTransaction.menu.ticket",
            textType: "I18N",
            func: () => viewTicket(),
        },
        {
            text: "comexTransaction.menu.share",
            textType: "I18N",
            func: () =>
                setActionDrawer({
                    showDrawer: true,
                    contentDrawer: <Compose idTransaction={transaction?.idTransaction} />,
                }),
        },
    ];

    const getCodeMsg = (code) => {
        if (code == "FINISHED") {
            return "APROBADA";
        }

        if (code == "FAILED") {
            return "RECHAZADA";
        }

        if (code === "SENT_TO_BANK") {
            return "ENVIADA";
        }
        if (code === "PENDING") {
            return "PENDIENTE";
        }
        return code;
    };
    const [showVoucherInfo, setShowVoucherInfo] = useState(false);

    const VoucherInfo = () => (
        <Drawer className="help-slider" openSidebar={showVoucherInfo} toggleSidebar={() => setShowVoucherInfo(false)}>
            <div className="container payway-terminal-type-help-container">
                <div
                    className="row"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: i18n.get("comex.voucher.info.content"),
                    }}
                />
            </div>
        </Drawer>
    );

    return (
        <>
            <VoucherInfo />
            <GridTable.Data columnStart={1} columnWidth={1} rowStart={1} alignX="center">
                {isDesktop ? (
                    <CustomText text={transaction.beneficiary} />
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.beneficiary"
                        titleTextType="I18N"
                        valueText={transaction?.beneficiary}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 2 : 1}
                columnWidth={1}
                rowStart={isDesktop ? 1 : 2}
                alignX="center">
                {isDesktop ? (
                    <>
                        <CustomText text={transaction?.currency} />
                        &nbsp;
                        <CustomText text={numberUtils.formatAmountStrDouble(transaction?.totalAmount)} />
                    </>
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.amount"
                        titleTextType="I18N"
                        valueText={`${transaction?.currency} ${numberUtils.formatAmountStrDouble(
                            transaction?.totalAmount,
                        )}`}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 3 : 1}
                columnWidth={1}
                rowStart={isDesktop ? 1 : 3}
                alignX="center">
                {isDesktop ? (
                    <FormattedDate date={transaction?.creationDate} dateFormat="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.creationDate"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={transaction?.creationDate} dateFormat="DD/MM/YYYY" />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 4 : 1}
                columnWidth={1}
                rowStart={isDesktop ? 1 : 4}
                alignX="center">
                {isDesktop ? (
                    <CustomText
                        text={String(transaction?.idTransaction.substring(0, 8).toUpperCase())}
                        className="content-data-strong"
                    />
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.idTransaction"
                        titleTextType="I18N"
                        valueText={String(transaction?.idTransaction.substring(0, 8).toUpperCase())}
                        showTooltip
                        onTooltipClick={() => setShowVoucherInfo(true)}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 5 : 1}
                columnWidth={1}
                rowStart={isDesktop ? 1 : 5}
                alignX="center">
                {isDesktop ? (
                    <InfoTag
                        type="info"
                        message={getCodeMsg(transaction?.metaStatus)}
                        tagBackground={statusTagColor(transaction?.status)}
                    />
                ) : (
                    <CustomData
                        titleText="comexTransaction.table.status"
                        titleTextType="I18N"
                        valueText={
                            <InfoTag
                                type="info"
                                message={getCodeMsg(transaction?.metaStatus)}
                                tagBackground={statusTagColor(transaction?.status)}
                            />
                        }
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 6 : 5}
                columnWidth={1}
                rowStart={1}
                alignY="center"
                className="adhered-services-button"
                alignX="center">
                <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
            </GridTable.Data>
        </>
    );
};

TransactionItem.propTypes = {
    receivedAdheredService: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
    payScheduledService: func.isRequired,
};

export default TransactionItem;
